module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "w-600"
  }, [_c('div', {
    staticClass: "p-l-50 p-t-30 p-b-30"
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "rules": _vm.rules,
      "label-width": "130px"
    }
  }, [_c('div', {
    staticClass: "m-b-10 p-20 bor-ccc pos-rel"
  }, [_c('div', {
    staticClass: "tit"
  }, [_vm._v("基础参数")]), _vm._v(" "), _c('div', [_c('el-form-item', {
    attrs: {
      "label": "系统名称",
      "prop": "SYSTEM_NAME"
    }
  }, [_c('el-input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.form.SYSTEM_NAME),
      expression: "form.SYSTEM_NAME",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "h-40 w-200",
    domProps: {
      "value": (_vm.form.SYSTEM_NAME)
    },
    on: {
      "input": function($event) {
        _vm.form.SYSTEM_NAME = (typeof $event === 'string' ? $event.trim() : $event)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "LOGO"
    }
  }, [_c('el-upload', {
    staticClass: "avatar-uploader",
    attrs: {
      "drag": "",
      "action": _vm.uploadUrl,
      "thumbnail-mode": true,
      "on-preview": _vm.viewPic,
      "on-remove": _vm.handleRemove,
      "on-success": _vm.uploadSuccess,
      "on-error": _vm.uploadFail,
      "file-list": _vm.fileList
    }
  }, [(_vm.form.SYSTEM_LOGO) ? _c('img', {
    staticStyle: {
      "width": "100%",
      "max-height": "300px"
    },
    attrs: {
      "src": _vm.imgUrl + _vm.form.SYSTEM_LOGO
    }
  }) : _c('i', {
    staticClass: "el-icon-upload"
  }), _vm._v(" "), _vm._v(" "), _vm._v(" "), _c('div', {
    staticClass: "el-upload__tip",
    slot: "tip"
  }, [_vm._v("将文件拖到此处，或"), _c('em', [_vm._v("点击上传")]), _vm._v("，只能上传jpg/png文件")])]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.form.SYSTEM_LOGO),
      expression: "form.SYSTEM_LOGO"
    }],
    on: {
      "click": _vm.clearLogo
    }
  }, [_vm._v("清除图片")])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "是否开启记录日志"
    }
  }, [_c('el-radio-group', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.IS_LOG),
      expression: "form.IS_LOG"
    }],
    domProps: {
      "value": (_vm.form.IS_LOG)
    },
    on: {
      "input": function($event) {
        _vm.form.IS_LOG = $event
      }
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "1"
    }
  }, [_vm._v("是")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "0"
    }
  }, [_vm._v("否")])])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "登录会话有效期",
      "prop": "LOGIN_SESSION_VALID"
    }
  }, [_c('el-input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.LOGIN_SESSION_VALID),
      expression: "form.LOGIN_SESSION_VALID"
    }],
    staticClass: "h-40 w-200",
    domProps: {
      "value": (_vm.form.LOGIN_SESSION_VALID)
    },
    on: {
      "input": function($event) {
        _vm.form.LOGIN_SESSION_VALID = $event
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "m-b-10 p-20 bor-ccc pos-rel"
  }, [_c('div', {
    staticClass: "tit"
  }, [_vm._v("登录页配置")]), _vm._v(" "), _c('div', [_c('el-form-item', {
    attrs: {
      "label": "登录框标题",
      "prop": "LOGIN_TITLE"
    }
  }, [_c('el-input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.form.LOGIN_TITLE),
      expression: "form.LOGIN_TITLE",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "h-40 w-300",
    domProps: {
      "value": (_vm.form.LOGIN_TITLE)
    },
    on: {
      "input": function($event) {
        _vm.form.LOGIN_TITLE = (typeof $event === 'string' ? $event.trim() : $event)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "登录验证码"
    }
  }, [_c('el-radio-group', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.IDENTIFYING_CODE),
      expression: "form.IDENTIFYING_CODE"
    }],
    domProps: {
      "value": (_vm.form.IDENTIFYING_CODE)
    },
    on: {
      "input": function($event) {
        _vm.form.IDENTIFYING_CODE = $event
      }
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "1"
    }
  }, [_vm._v("打开")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "0"
    }
  }, [_vm._v("关闭")])])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "版权信息",
      "prop": "COPYRIGHT"
    }
  }, [_c('el-input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.form.COPYRIGHT),
      expression: "form.COPYRIGHT",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "h-40 w-300",
    attrs: {
      "type": "textarea"
    },
    domProps: {
      "value": (_vm.form.COPYRIGHT)
    },
    on: {
      "input": function($event) {
        _vm.form.COPYRIGHT = (typeof $event === 'string' ? $event.trim() : $event)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "界面底色",
      "prop": "LOGIN_BG_COLOR"
    }
  }, [_c('el-select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.LOGIN_BG_COLOR),
      expression: "form.LOGIN_BG_COLOR"
    }],
    staticClass: "h-40 w-300",
    domProps: {
      "value": (_vm.form.LOGIN_BG_COLOR)
    },
    on: {
      "input": function($event) {
        _vm.form.LOGIN_BG_COLOR = $event
      }
    }
  }, _vm._l((_vm.bgColors), function(option) {
    return _c('el-option', {
      attrs: {
        "label": option.name,
        "value": option.id
      }
    })
  }))]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "界面背景图（可选）"
    }
  }, [_c('el-upload', {
    staticClass: "avatar-uploader",
    attrs: {
      "drag": "",
      "action": _vm.uploadUrl,
      "thumbnail-mode": true,
      "on-preview": _vm.viewPic,
      "on-remove": _vm.handleRemove,
      "on-success": _vm.uploadBgImgSuccess,
      "on-error": _vm.uploadFail,
      "file-list": _vm.bgImgList
    }
  }, [(_vm.form.LOGIN_BG_IMG) ? _c('img', {
    staticStyle: {
      "width": "100%",
      "max-height": "300px"
    },
    attrs: {
      "src": _vm.imgUrl + _vm.form.LOGIN_BG_IMG
    }
  }) : _c('i', {
    staticClass: "el-icon-upload"
  }), _vm._v(" "), _vm._v(" "), _vm._v(" "), _c('div', {
    staticClass: "el-upload__tip",
    slot: "tip"
  }, [_vm._v("将文件拖到此处，或"), _c('em', [_vm._v("点击上传")]), _vm._v("，只能上传jpg/png文件")])]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.form.LOGIN_BG_IMG),
      expression: "form.LOGIN_BG_IMG"
    }],
    on: {
      "click": _vm.clearBgImg
    }
  }, [_vm._v("清除图片")])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "界面动画组件"
    }
  }, [_c('el-select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.ANIMATION_FRAME),
      expression: "form.ANIMATION_FRAME"
    }],
    staticClass: "h-40 w-300",
    domProps: {
      "value": (_vm.form.ANIMATION_FRAME)
    },
    on: {
      "input": function($event) {
        _vm.form.ANIMATION_FRAME = $event
      }
    }
  }, _vm._l((_vm.animationOptions), function(option) {
    return _c('el-option', {
      attrs: {
        "label": option.name,
        "value": option.id
      }
    })
  }))])])]), _vm._v(" "), _c('div', {
    staticClass: "m-b-10 p-20 bor-ccc pos-rel"
  }, [_c('div', {
    staticClass: "tit"
  }, [_vm._v("企业微信")]), _vm._v(" "), _c('div', [_c('el-form-item', {
    attrs: {
      "label": "企业微信"
    }
  }, [_c('el-radio-group', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.USE_WECHAT_WORK),
      expression: "form.USE_WECHAT_WORK"
    }],
    domProps: {
      "value": (_vm.form.USE_WECHAT_WORK)
    },
    on: {
      "input": function($event) {
        _vm.form.USE_WECHAT_WORK = $event
      }
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "1"
    }
  }, [_vm._v("打开")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "0"
    }
  }, [_vm._v("关闭")])])]), _vm._v(" "), (_vm.form.USE_WECHAT_WORK == 1) ? _c('div', [_c('el-form-item', {
    attrs: {
      "label": "默认密码",
      "prop": "DEFAUTL_PASSWD"
    }
  }, [_c('el-input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.form.DEFAUTL_PASSWD),
      expression: "form.DEFAUTL_PASSWD",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "h-40 w-200",
    domProps: {
      "value": (_vm.form.DEFAUTL_PASSWD)
    },
    on: {
      "input": function($event) {
        _vm.form.DEFAUTL_PASSWD = (typeof $event === 'string' ? $event.trim() : $event)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "微信消息跳转路径"
    }
  }, [_c('el-input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.form.WECHAT_MSG_URL),
      expression: "form.WECHAT_MSG_URL",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "h-40 w-200",
    domProps: {
      "value": (_vm.form.WECHAT_MSG_URL)
    },
    on: {
      "input": function($event) {
        _vm.form.WECHAT_MSG_URL = (typeof $event === 'string' ? $event.trim() : $event)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Corpid",
      "prop": "APP_ID"
    }
  }, [_c('el-input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.form.APP_ID),
      expression: "form.APP_ID",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "h-40 w-200",
    domProps: {
      "value": (_vm.form.APP_ID)
    },
    on: {
      "input": function($event) {
        _vm.form.APP_ID = (typeof $event === 'string' ? $event.trim() : $event)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _vm._v(" "), _c('div', {
    staticClass: "agentsTab"
  }, [_c('el-table', {
    staticClass: "m-b-10 w-650",
    attrs: {
      "data": _vm.form.agents,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "应用名称"
    },
    scopedSlots: {
      default: function(scope) {
        return [_c('el-input', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (scope.row.name),
            expression: "scope.row.name"
          }],
          attrs: {
            "placeholder": "应用名称"
          },
          domProps: {
            "value": (scope.row.name)
          },
          on: {
            "input": function($event) {
              scope.row.name = $event
            }
          }
        })]
      }
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "agent_id",
      "label": "应用ID"
    },
    scopedSlots: {
      default: function(scope) {
        return [_c('el-input', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (scope.row.agent_id),
            expression: "scope.row.agent_id"
          }],
          attrs: {
            "placeholder": "应用名称"
          },
          domProps: {
            "value": (scope.row.agent_id)
          },
          on: {
            "input": function($event) {
              scope.row.agent_id = $event
            }
          }
        })]
      }
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "secret",
      "label": "秘钥"
    },
    scopedSlots: {
      default: function(scope) {
        return [_c('el-input', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (scope.row.secret),
            expression: "scope.row.secret"
          }],
          staticClass: "w-120",
          attrs: {
            "placeholder": "秘钥"
          },
          domProps: {
            "value": (scope.row.secret)
          },
          on: {
            "input": function($event) {
              scope.row.secret = $event
            }
          }
        })]
      }
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作"
    },
    scopedSlots: {
      default: function(scope) {
        return [_c('div', [_c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              _vm.delAgent(scope.$index)
            }
          }
        }, [_vm._v("删除")])])]
      }
    }
  })]), _vm._v(" "), _c('el-button', {
    staticClass: "m-b-10",
    attrs: {
      "type": "success"
    },
    on: {
      "click": _vm.addApplication
    }
  }, [_vm._v("添加新应用")])])]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "m-t-20"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.isLoading
    },
    on: {
      "click": function($event) {
        _vm.add()
      }
    }
  }, [_vm._v("提交")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.goback()
      }
    }
  }, [_vm._v("返回")])]), _vm._v(" "), _c('preview', {
    ref: "preview",
    attrs: {
      "url": _vm.propsImg
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-39104a96!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Administrative/system/config/add.vue
// module id = 1824
// module chunks = 2